module.exports = __webpack_public_path__ + "static/media/white-point-measure-icon.60f0a029.svg";